module.exports = __webpack_public_path__ + "img/lena-ortner.49643cc6.jpg";